import React, { FC, useState } from 'react';
import { ThemeContextAction, ThemeContextValue } from '@lib/ThemeContext';
import { themeLight } from '@lib/nafTheme';

interface Props {
  children?: React.ReactNode;
}

export const ThemeContextProvider: FC<Props> = ({ children }) => {
  // Start from the theme the server rendered (ThemedApp's fallback), so useTheme's mount effect
  // setting that same object is a no-op instead of re-rendering the whole app after hydration.
  const [theme, setTheme] = useState(themeLight);
  return (
    <ThemeContextAction.Provider value={setTheme}>
      <ThemeContextValue.Provider value={theme}>{children}</ThemeContextValue.Provider>
    </ThemeContextAction.Provider>
  );
};
